import { computed, inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { gtag } from '../classes/gtag';
import { GroupConfigService } from './group.config.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  protected readonly groupConfig = inject(GroupConfigService);
  protected siteStreamId  = environment.analyticsId;
  protected groupStreamId = computed<string|undefined>(() => {
    const streamId = this.groupConfig.current()?.analyticsId;
    if(streamId === this.siteStreamId) throw new Error(`siteのStreamIdとgroupのstreamIdが同じです`);
    return this.addStreamId(streamId)
  });
  //
  constructor() {
    this.addStreamId(this.siteStreamId);
  }
  //
  addStreamId(streamId:string|undefined){
    if(streamId === undefined) return;
    gtag.config(streamId,{send_page_view:false});
    return streamId;
  }
  //
  pageView($_:Parameters<typeof gtag.event.page_view>[0] = {}){
    gtag.event.page_view($_)
  }
}
/* **********************************************************************
 * index.htmlのヘッダー内に以下を追加
 * **********************************************************************
<!-- Google tag (gtag.js) : ブラウザの履歴イベントに基づくページの変更をオフにする事 -->
<script async src="https://www.googletagmanager.com/gtag/js"></script>
<script>
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
</script>
*/
